import { useGetFrontTipiDomandaId } from '@framework/api-client';
import { useAuth } from '@framework/auth';
import {
  CoverParagraphs,
  selectTranslatedInquiryType,
  SubmissionResponsiveCard,
  TitleSubmissionRow,
} from '@framework/common-web';
import { FlexSubmissionRow } from '@framework/frontoffice-submission/src/submission/FlexSubmissionRow';
import { useTranslation } from '@framework/i18n';
import { BrandedPath, useBreadcrumbItem } from '@framework/ui';
import { RouteComponentProps } from 'react-router';
import { PageLayout } from '../../../ui/layout/PageLayout';
import { NetworkAlertPage } from '../../errors/network-alert/NetworkAlertPage';
import { LoadingPage } from '../../loading/LoadingPage';
import { useFetchCategoryLabel } from '../list/useFetchCategoryLabel';
import { CoverImage } from './component/CoverImage';
import { InquiryItem } from './inquiry/InquiryItem';

interface Params {
  id: string;
  categoryId?: string;
}

export interface IInquiryCoverPageProps extends RouteComponentProps<Params> {}

export function InquiryCoverPage(props: IInquiryCoverPageProps) {
  const { id: inquiryId, categoryId } = props.match.params;

  const { isLogged } = useAuth();
  const { t } = useTranslation();

  const { data, error, isLoading } = useGetFrontTipiDomandaId(inquiryId, {
    query: { keepPreviousData: true, select: selectTranslatedInquiryType },
  });

  const { categoryLabel, isLoading: isCategoryLabelLoading } =
    useFetchCategoryLabel(categoryId);

  const path = (
    categoryId ? `/categoria/${categoryId}` : '/domande'
  ) as BrandedPath;

  useBreadcrumbItem({
    path: isLogged ? path : '/',
    title: categoryLabel || t('inquiry.lista.briciole.domande', 'Domande'),
  });

  useBreadcrumbItem({
    path: props.location.pathname as BrandedPath,
    title: data?.titolo ?? t('inquiry.lista.briciole.domanda', 'Domanda'),
  });

  if (isLoading || isCategoryLabelLoading) return <LoadingPage />;

  if (error) {
    return (
      <NetworkAlertPage
        message={t(
          'inquiry-cover.errore-caricamento-copertina-domanda',
          'Impossibile caricare la copertina della domanda',
        )}
        error={error}
      />
    );
  }
  const cover = data?.copertina;
  if (!cover) {
    return (
      <NetworkAlertPage
        message={t(
          'inquiry-cover.errore-caricamento-copertina-domanda',
          'Impossibile caricare la copertina della domanda',
        )}
        error={new Error('No cover data found')}
      />
    );
  }

  return (
    <PageLayout>
      <SubmissionResponsiveCard
        title={
          <TitleSubmissionRow>
            {cover.titolo ??
              data.titolo ??
              t('inquiry-cover.titolo-non-presente', 'Titolo non presente')}
          </TitleSubmissionRow>
        }
      >
        <FlexSubmissionRow
          menu={<InquiryItem inquiry={data} />}
          menuSide="right"
        >
          <CoverImage cover={cover} />
          <CoverParagraphs paragraphs={cover.paragrafi} />
        </FlexSubmissionRow>
      </SubmissionResponsiveCard>
    </PageLayout>
  );
}
